import { api } from "./api";

export interface PostCase {
  postCaseId: number;
  postId: number;
  /** @deprecated 화면에서는 더 이상 쓰지 않는다 (API 에는 아직 남아 있음) */
  label?: string;
  name?: string;
  organ?: string;
  note?: string;
  gender?: string;
  age?: string;
  listOrder: number;
  createdAt?: string;
  modifiedAt?: string;
}

export interface CreatePostCasePayload {
  postId: number;
  name?: string;
  organ?: string;
  note?: string;
  gender?: string;
  age?: string;
  listOrder?: number;
}

export interface UpdatePostCasePayload {
  postCaseId: number;
  name?: string;
  organ?: string;
  note?: string;
  gender?: string;
  age?: string;
}

export interface AssignPayload {
  postCaseId: number;
  slideIds?: number[];
  photoIds?: number[];
  grossPhotoIds?: number[];
}

export interface UnassignPayload {
  slideIds?: number[];
  photoIds?: number[];
  grossPhotoIds?: number[];
}

export const postCaseDisplayName = (postCase: PostCase, index: number) =>
  postCase.name?.trim() || `Case ${index + 1}`;

export const getPostCaseList = async (postId: number): Promise<PostCase[]> => {
  try {
    const { data } = await api().get("/post-case/list", { params: { postId } });
    return data.data ?? [];
  } catch (e: any) {
    console.error("getPostCaseList error:", e);
    return [];
  }
};

export const createPostCase = async (payload: CreatePostCasePayload) => {
  try {
    const { data } = await api().post("/post-case", payload);
    return { success: true, data: data?.data };
  } catch (e: any) {
    console.error("createPostCase error:", e);
    const message =
      e.response?.data?.message || "케이스 등록 중 오류가 발생했습니다.";
    return { success: false, message };
  }
};

export const updatePostCase = async (payload: UpdatePostCasePayload) => {
  try {
    const { data } = await api().post("/post-case/update", payload);
    return { success: true, data: data?.data };
  } catch (e: any) {
    console.error("updatePostCase error:", e);
    const message =
      e.response?.data?.message || "케이스 수정 중 오류가 발생했습니다.";
    return { success: false, message };
  }
};

export const deletePostCase = async (payload: {
  postCaseId: number;
  organ?: string;
  note?: string;
  gender?: string;
  age?: string;
}) => {
  try {
    const { data } = await api().post("/post-case/delete", payload);
    return { success: true, data: data?.data };
  } catch (e: any) {
    console.error("deletePostCase error:", e);
    const message =
      e.response?.data?.message || "케이스 삭제 중 오류가 발생했습니다.";
    return { success: false, message };
  }
};

export const assignToPostCase = async (payload: AssignPayload) => {
  try {
    const { data } = await api().post("/post-case/assign", payload);
    return { success: true, data: data?.data };
  } catch (e: any) {
    console.error("assignToPostCase error:", e);
    const message =
      e.response?.data?.message || "케이스 배정 중 오류가 발생했습니다.";
    return { success: false, message };
  }
};

export const unassignFromPostCase = async (payload: UnassignPayload) => {
  try {
    const { data } = await api().post("/post-case/unassign", payload);
    return { success: true, data: data?.data };
  } catch (e: any) {
    console.error("unassignFromPostCase error:", e);
    const message =
      e.response?.data?.message || "케이스 배정 해제 중 오류가 발생했습니다.";
    return { success: false, message };
  }
};

//케이스 순서 일괄 변경.
//listOrder 는 1부터 시작 (createPostCase 의 nextListOrder 와 동일 기준)
export const reorderPostCases = async (
  caseList: { postCaseId: number; listOrder: number }[]
) => {
  try {
    const { data } = await api().put("/post-case/listOrder/list", caseList);
    return { success: true, data: data?.data };
  } catch (e: any) {
    console.error("reorderPostCases error:", e);
    const message =
      e.response?.data?.message || "케이스 순서 변경 중 오류가 발생했습니다.";
    return { success: false, message };
  }
};
